import { Config } from 'containers/AppContainer/typings';
import { VICTIM_EXPERTISE_FIELDS } from 'containers/data-structure';
import { mapObject } from 'helpers/object-helper';
import { get } from 'lodash';

export const formatParamValue = (item: Config) => {
  if (item.percentage) {
    return `${item.title}; ${item.percentage}%`;
  }
  return `${item.title}`;
};

export const configToItems = (items: Config[]) =>
  items &&
  items.map(({ title, percentage }: Config) => ({
    label: formatParamValue({ title, percentage } as Config) || '',
    value: percentage,
  }));
export const getEvaluationConfigFields = (victimExpertise: any) => {
  const vicExp = mapObject(victimExpertise, (el: unknown) => {
    if (el === null) return '';

    return el;
  });

  return {
    [VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL]: String(
      get(vicExp, VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL, ''),
    ),

    [VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS]: String(
      get(vicExp, VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS, ''),
    ),
    [VICTIM_EXPERTISE_FIELDS.MEDICAL_PHARMACEUTICAL_FEES]: String(
      get(vicExp, VICTIM_EXPERTISE_FIELDS.MEDICAL_PHARMACEUTICAL_FEES, ''),
    ),
    [VICTIM_EXPERTISE_FIELDS.IPP]: String(
      get(vicExp, VICTIM_EXPERTISE_FIELDS.IPP, ''),
    ),
    [VICTIM_EXPERTISE_FIELDS.ITT]: String(
      get(vicExp, VICTIM_EXPERTISE_FIELDS.ITT, ''),
    ),
    [VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE]: String(
      get(
        vicExp,
        VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE,
        '',
      ),
    ),
    [VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE]: String(
      get(
        vicExp,
        VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE,
        '',
      ),
    ),
    [VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE]: String(
      get(vicExp, VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE, ''),
    ),
    [VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE]: String(
      get(vicExp, VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE, ''),
    ),
  };
};
/* istanbul ignore next */
export const convertNumberToString = (number: any) => {
  if (number === 0) {
    return '0';
  } else {
    return number;
  }
};
